module.exports = __webpack_public_path__ + "img/changePassword.8a98c2f9.svg";